import { useMemo } from "react";
import useAuth from "./useAuth";

/**
 * Extracts the `access_expires_at_epoch` custom claim from the Keycloak token.
 *
 * The value is a Unix timestamp in **seconds**. This field may be present on
 * both Chargebee subscribers and directly-provisioned users.
 */
export const useAccessExpiresAtEpoch = () => {
  const { authenticated, tokenParsed } = useAuth();

  return useMemo(() => {
    if (!authenticated || !tokenParsed) {
      return { expiresAtDate: null, isExpired: false };
    }

    const epoch = (tokenParsed as Record<string, unknown>)
      .access_expires_at_epoch;

    if (epoch == null) {
      return { expiresAtDate: null, isExpired: false };
    }

    const expiresAtMs = Number(epoch) * 1000;
    if (Number.isNaN(expiresAtMs)) {
      return { expiresAtDate: null, isExpired: false };
    }

    return {
      expiresAtDate: new Date(expiresAtMs),
      isExpired: expiresAtMs < Date.now(),
    };
  }, [authenticated, tokenParsed]);
};
